import {GET_ALL_TEMPLATES, TEMPLATES_INIT_STATE} from "./types";

export const templatesReducer = (state = TEMPLATES_INIT_STATE, action) => {
    switch (action.type) {
        case GET_ALL_TEMPLATES:
            return action.templates;
        default:
            return state
    }
}